module.exports = __webpack_public_path__ + "img/logo-footer-ca.5cda9c71.png";